import AnexoBusiness from "@/business/AnexoBusiness.js";
import EnderecoBusiness from "@/business/EnderecoBusiness";
import RestricaoBusiness from "@/business/RestricaoBusiness";
import CachedApi from "@/commons/CachedApi.js";
import Http from "@/commons/Http";
import Utils from "@/commons/Utils";
import VueBusiness from "@/business/VueBusiness";
import AuditoriaBusiness from "@/business/AuditoriaBusiness";
import IndicadorRealBusiness from "@/business/indicadores/IndicadorRealBusiness";
import DominioBusiness from "@/business/protocolo/DominioBusiness";

const path = 'api/indicador-real';

const tratarAto = (a) => {
  if(a.tipoServico) a.tipoServico = JSON.parse(a.tipoServico);
  if(a.tipoServico?.opcoes && typeof a.tipoServico?.opcoes === 'string'){
    a.tipoServico.opcoes = JSON.parse(a.tipoServico.opcoes || false)
  }
  if(a.validador) a.validador = JSON.parse(a.validador);
  if(a.protocolo) a.protocolo = JSON.parse(a.protocolo);
  return a;
};

const tratarAtoSJ = (a) => {
  if(a.situacaoJuridica) a.situacaoJuridica = JSON.parse(a.situacaoJuridica);
  return a;
};

export default {

  async gerarCNM(id) {
    return Http.post(`${path}/${id}/gerar-cnm`);
  },

  async removerCNM(id) {
    return Http.post(`${path}/${id}/remover-cnm`);
  },

  async pagination(sort, direction, page, size, filters = {}){
    return Http.post(`${path}/pagination?sort=${sort || 'i.codigo'},${direction || 'desc'}&page=${page || 1}&size=${size || 10}`, filters);
  },

  async paginationV2(sort, direction, page, size, filters = {}){
    return Http.post(`${path}/v2/pagination?sort=${sort || 'i.codigo'},${direction || 'desc'}&page=${page || 1}&size=${size || 10}`, filters);
  },

  async getById(id){
    if(!Utils.testUUID(id)){
      return Promise.reject();
    }
    return Http.get(`${path}/${id}`);
  },

  async delete(id){
    return Http.delete(`${path}/${id}`);
  },

  async atosRegistrados(id){
    return Http.get(`${path}/${id}/atos`).then(l => l.map(tratarAto));
  },

  async analiseSituacaoJuridica(id){
    return Http.get(`${path}/${id}/situacao-juridica/atos`).then(l => l.map(tratarAtoSJ));
  },

  async buscarAtosRegistrados(id){
    return Http.get(`${path}/${id}/atos-registrados`).then(l => l.map(tratarAto));
  },

  async buscarUltimaAuditoriaImpressaoAto(id){
    return Http.get(`${path}/${id}/ultima-auditoria-impressao`);
  },

  async verificarAtosImpressao(id){
    return Http.get(`${path}/${id}/atos-impressao`);
  },

  async ultimoAtoRegistrado(id){
    return Http.get(`${path}/${id}/ultimo-ato-registrado`).then(a => tratarAto(a));
  },

  async historico(id, page, size){
    return Http.get(`${path}/${id}/historico?page=${page || 1}&size=${size || 10}`);
  },

  async cancelarUltimoAto(indicadorRealId) {
    return await Http.post(`${path}/${indicadorRealId}/ato/cancelar-ultimo-ato`);
  },

  async setImpressao(id, imprimindo) {
    return Http.post(`${path}/${id}/ato-impressao/${imprimindo}`);
  },

  async buscarProtocolosAtivos(id){
    return Http.get(`${path}/${id}/protocolos-ativos`);
  },

  async buscarAtosTabelionato(id){
    return Http.get(`${path}/${id}/atos-tabelionato`);
  },

  async buscarProtocolos(id){
    return Http.get(`${path}/${id}/protocolos`);
  },

  async listarUnidades(id, sort, direction){
    return Http.get(`${path}/${id}/unidades?sort=${sort || 'ordem'},${direction || 'asc'}`);
  },

  async buscarExProprietarios(id){
    return Http.get(`${path}/${id}/ex-proprietarios`);
  },

  async proprietariosAtuais(id){
    return Http.get(`${path}/${id}/proprietarios`);
  },

  async restricoesVigentes(id){
    return Http.get(`${path}/${id}/restricoes-vigentes`);
  },

  async restricoesCanceladas(id){
    return Http.get(`${path}/${id}/restricoes-canceladas`);
  },

  async restricoes(id, registroAto){
    if(Utils.isEmptyNullOrUndefined(registroAto)) registroAto = '';
    return Http.get(`${path}/${id}/restricoes/${registroAto}`).then(r => r.map(RestricaoBusiness.tratarRestricoes));
  },

  async buscarAtosPorVersaoIndicadorPessoal(indicadorRealId, indicadorPessoalId){
    return Http.get(`${path}/${indicadorRealId}/${indicadorPessoalId}/atos-por-versao-indicador-pessoal`);
  },

  async possuiIndisponibilidades(id) {
    return CachedApi.getCached('indisponibilidades-'+id, async () => {
      return Http.get(`${path}/${id}/possui-indisponibilidades`);
    });
  },

  async save(id, dto, origemId = '') {
    if (!id) {
      return Http.post(`${path}/lote/1/${origemId}`, dto);
    }
    return Http.post(`${path}/${id}`, dto);
  },

  async validarDadosCadastroIndicador(indicador){
    return Http.post(`${path}/validar-dados-cadastro-indicador/`, indicador);
  },

  async validarDadosCadastroIndicadorConfirmacao(indicador, ci, qlb){
    return Http.post(`${path}/validar-dados-cadastro-indicador-confirmacao/`, indicador);
  },

  async lote(dto, onProgress) {
    const chunkSize = 200;
    for (let i = 0; i < dto.length; i += chunkSize) {
      const chunk = dto.slice(i, i + chunkSize);
      await Http.post(`${path}/lote`, chunk);
      if (onProgress) onProgress(Math.min(i + chunkSize, dto.length), dto.length);
    }
    return true;
  },

  async editarTextoLegado(id, dto) {
    return Http.post(`${path}/${id}/texto-legado`, dto);
  },

  async saveImportacao(origemId, file) {
    const formData = new FormData();
    formData.append("file", file);

    let config = {
      timeout: 0,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    };
    return Http.post(`${path}/lote-importacao/${origemId}`, formData, config);
  },

  async criarTranscricao(dto) {
    return Http.post(`${path}/transcricao`, dto);
  },

  async criarLote(quantidade, dto) {
    return Http.post(`${path}/lote/${quantidade}`, dto);
  },

  async criarLoteArquivo(file) {

    const formData = new FormData();
    formData.append("file", file);

    let config = {
      timeout: 0,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    };

    return Http.post(`${path}/lote-arquivo`, formData, config);
  },

  async getFichaPorCodigo(livro, codigo) {
    return Http.get(`${path}/codigo/${livro}/${codigo}`);
  },

  async getFichasPorCodigo(params = {}) {
    const {livro, status, dto, completo} = params;
    return await Http.post(`${path}/${completo ? 'completo-' : ''}codigos/${status}/${livro}`, dto);
  },

  async getFichasPorId(ids) {
    return await Http.post(`${path}/ids`, ids);
  },

  async sugerirServentia(query) {
    return Http.get(`${path}/sugerir/serventia/${query}`)
      .catch(e => e);
  },

  async removerUnidade(unidadeId) {
    return Http.post(`${path}/${unidadeId}/remover-unidade`);
  },

  async ordenarUnidades(id, unidades) {
    return Http.post(`${path}/${id}/unidades/ordenar`, unidades);
  },

  async digitalizacaoDesatualizada(id){
    return Http.get(`${path}/${id}/digitalizacao-desatualizada`);
  },

  async impressaoDesatualizada(id){
    return Http.get(`${path}/${id}/impressao-desatualizada`);
  },

  async indicadorRealValidado(id){
    return Http.get(`${path}/valido/${id}`);
  },

  async validaCadastroImoliliario(id, dto) {
    return Http.post(`${path}/valida-cadastro-imobiliario${id ? `/${id}` : ''}`, dto);
  },

  async validarInscricaoImobiliaria(cadastroImobiliario) {
    if (!cadastroImobiliario) return true;
    return Http.get(`${path}/validar-inscricao-imobiliaria/${cadastroImobiliario}`);
  },

  async validaQuadraLoteBairro(id, dto) {
    return Http.post(`${path}/valida-quadra-lote-bairro${id ? `/${id}` : ''}`, dto);
  },

  async getAtos(indicadorRealId, atoId = '', registrado = false, selado = false){
    const tratarObjeto = (item) => {
      item.ato = JSON.parse(item.ato);
      return item;
    };
    return Http.get(`${path}/atos-indicador/${indicadorRealId}/${atoId}/${registrado}/${selado}`).then(response => response.map(tratarObjeto));
  },

  async getVinculos(id){
    return Http.get(`${path}/${id}/vinculos`);
  },

  async getTranscricoesRelacionadas(id){
    return Http.get(`${path}/${id}/transcricoes-relacionadas`);
  },

  exportarRegistrosPosteriores(id, direction) {
    return `${path}/${id}/exportar-registros-posteriores?sort=codigo,${direction || 'desc'}`;
  },

  async sugerirCampo(campo, query){
    if (query.trim().length < 3) {
      return null;
    }
    return Http.get(`${path}/sugerir/${campo}/${query}`);
  },

  async buscarAtosAlteracaoIndicador(id){
    return Http.get(`${path}/${id}/atos-alteracao-indicador`).then(l => l.map((a) => {
      if(a.indicador) a.indicador = JSON.parse(a.indicador);
      return a;
    }));
  },

  getMedidas() {
    return [
      {id: 'PERCENTUAL', nome: '%', singular: 'inteiro', plural: 'inteiros', decimal: 'centésimo por cento', decimalPlural: 'centésimos por cento'},
      {id: 'M2', nome: 'm²', singular: 'metro quadrado', plural: 'metros quadrados', decimal: 'decímetro', decimalPlural: 'decímetros'},
      {id: 'HA', nome: 'hectare', singular: 'hectare', plural: 'hectares', decimal: 'are', decimalPlural: 'ares'},
      {id: 'ACRE', nome: 'acre', singular: 'acre', plural: 'acres', decimal: 'centésimo de acre', decimalPlural: 'centésimos de acre'},
      {id: 'ARE', nome: 'are', singular: 'are', plural: 'ares', decimal: 'centiare', decimalPlural: 'centiares'},
      {id: 'LITRO', nome: 'litro', singular: 'litro', plural: 'litros', decimal: 'centésimo de litro', decimalPlural: 'centésimos de litro'},
      {id: 'ALQUEIRE', nome: 'alqueire', singular: 'alqueire', plural: 'alqueires', decimal: 'centésimo de alqueire', decimalPlural: 'centésimos de alqueire'},
      {id: 'ALQUEIRE_PAULISTA', nome: 'alqueire paulista', singular: 'alqueire paulista', plural: 'alqueires paulista', decimal: 'centésimo de alqueire', decimalPlural: 'centésimos de alqueire'},
      {id: 'INEXISTENTE_OU_NAO_OFICIAL', nome: 'Inexistente/Medida não oficial', singular: '', plural: '', decimal: '', decimalPlural: ''},
    ];
  },

  getMedidasUniao() {
    return [
      {id: 'M2', nome: 'm²', singular: 'metro quadrado', plural: 'metros quadrados', decimal: 'decímetro', decimalPlural: 'decímetros'},
      {id: 'KM2', nome: 'km²', singular: 'quilômetro quadrado', plural: 'quilômetros quadrado', decimal: ''},
      {id: 'HA', nome: 'hectare', singular: 'hectare', plural: 'hectares', decimal: 'are', decimalPlural: 'ares'},
    ];
  },

  getRegimesImovelUniao(){
    return [
      {id: 'FORO_OCUPACAO', nome: 'Foro/Ocupação'},
      {id: 'AFORAMENTO', nome: 'Aforamento'},
      {id: 'OCUPACAO', nome: 'Ocupação'},
      {id: 'CDRU', nome: 'CDRU'},
      {id: 'CUEM', nome: 'CUEM'},
      {id: 'TAU', nome: 'TAU'},
      {id: 'NAO_SE_APLICA', nome: 'Não se aplica'},
    ]
  },

  getTiposImovel() {
    return [
      {id: 'APARTAMENTO', nome: 'Apartamento'},
      {id: 'LOTE', nome: 'Lote'},
      {id: 'TERRENO', nome: 'Terreno'},
      {id: 'CASA', nome: 'Casa'},
      {id: 'FAZENDA', nome: 'Fazenda'},
      {id: 'SITIO', nome: 'Sítio'},
      {id: 'CHACARA', nome: 'Chácara'},
      {id: 'GALPAO', nome: 'Galpão'},
      {id: 'PREDIO_COMERCIAL', nome: 'Prédio Comercial'},
      {id: 'PREDIO_RESIDENCIAL', nome: 'Prédio Residencial'},
      {id: 'SALA_COMERCIAL', nome: 'Sala/Conjunto'},
      {id: 'LOJA', nome: 'Loja'},
      {id: 'ESCANINHO', nome: 'Escaninho'},
      {id: 'HOBBY_BOX', nome: 'Hobby Box'},
      {id: 'VAGA_GARAGEM', nome: 'Vaga de Garagem'},
      {id: 'BOXE_GARAGEM', nome: 'Box de Garagem'},
      {id: 'SALA', nome: 'Sala'},
      {id: 'CONJUNTO_SALAS', nome: 'Conjunto de Salas'},
      {id: 'SOBRELOJA', nome: 'Sobreloja'},
      {id: 'SALA_LOJA', nome: 'Sala ou Loja'},
      {id: 'CONSTRUCOES', nome: 'Construções'},
      {id: 'DESMEMBRAMENTO', nome: 'Desmembramento'},
      {id: 'LAJE', nome: 'Laje'},
      {id: 'ESTACIONAMENTO', nome: 'Estacionamento'},
      {id: 'BARRACO', nome: 'Barraco'},
      {id: 'OUTROS', nome: 'Outros'}
    ];
  },

  getCategorias() {
    return [
      {id: 'URBANO', nome: 'Urbano'},
      {id: 'RURAL', nome: 'Rural'}
    ];
  },

  // Finalidade de uso do imóvel: lista CONTROLADA da ITN004 (ListaFinalidadeUsoImovelUrbano, v1.1).
  // Espelha o enum EnumFinalidadeUsoImovel do backend, que é a fonte da verdade — os ids são os
  // nomes das constantes. Valor fora desta lista não existe: não acrescentar item sem que ele venha
  // de uma versão nova da lista da ITN, e sempre atualizar os dois lados juntos.
  getFinalidadesUso() {
    return [
      {id: 'COMERCIAL', nome: 'Comercial'},
      {id: 'RESIDENCIAL', nome: 'Residencial'},
      {id: 'INDUSTRIAL', nome: 'Industrial'},
      {id: 'AREA_INSTITUCIONAL_PUBLICA_PARA_EQUIPAMENTO_URBANO', nome: 'Área institucional pública para equipamento urbano'},
      {id: 'AREA_INSTITUCIONAL_PUBLICA_PARA_EQUIPAMENTO_COMUNITARIO', nome: 'Área institucional pública para equipamento comunitário'},
      {id: 'ESPACO_LIVRE_DE_USO_PUBLICO_DE_AREA_VERDE', nome: 'Espaço livre de uso público de área verde'},
      {id: 'ESPACO_LIVRE_DE_USO_PUBLICO_DE_SISTEMA_DE_LAZER', nome: 'Espaço livre de uso público de sistema de lazer'},
      {id: 'SISTEMA_VIARIO_PUBLICO', nome: 'Sistema viário público'}
    ];
  },

  getTiposSig() {
    return [
      {id: 'IMOVEL_RURAL_GEORREFERENCIADO_COM_CERTIFICACAO', nome: 'a) imóvel rural georreferenciado com certificação da poligonal pelo Incra'},
      {id: 'IMOVEL_RURAL_GEORREFERENCIADO_SEM_CERTIFICACAO', nome: 'b) imóvel rural georreferenciado sem certificação da poligonal no Incra'},
      {id: 'IMOVEL_URBANO_GEORREFERENCIADO_COM_REURB', nome: 'a) imóvel urbano georreferenciado objeto de procedimento de Reurb'},
      {id: 'IMOVEL_URBANO_GEORREFERENCIADO_SEM_REURB', nome: 'b) imóvel urbano georreferenciado não abrangido pelo procedimento de Reurb'},
      {id: 'OUTRAS_SITUACOES', nome: 'c) outras situações'},
      {id: 'NAO_GEORREFERENCIADO', nome: 'd) não georreferenciado'}
    ];
  },

  getTiposReferencia() {
    return [
      {id: 'RESTRICAO', nome: 'Restrição'},
      {id: 'CANCELAMENTO_RESTRICAO', nome: 'Cancelamento de Restrição'},
      {id: 'ABERTURA', nome: 'Abertura de Matrícula'},
      {id: 'TRANSMISSAO', nome: 'Transmissão'},
      // A unidade que a ficha descreve e que continua nela. É o par de TRANSMISSAO no vocabulário
      // das unidades da matrícula-mãe, e existe para que o lote parado possa ser registrado sem que
      // o registro afirme uma saída que não houve. Ver `EnumTipoReferenciaImovel.UNIDADE_DESCRITA`.
      {id: 'UNIDADE_DESCRITA', nome: 'Unidade descrita (sem movimento)'},
      {id: 'MENCAO', nome: 'Menção'}
    ];
  },

  /**
   * Os tipos de referência que descrevem uma UNIDADE da matrícula-mãe — os que têm designação,
   * proprietários, área e fração por campo, e que a aba "Unidades" da ficha lê.
   *
   * A lista vive num lugar só porque cinco telas fazem a mesma pergunta: o formulário (mostrar os
   * campos da unidade), a validação do vínculo, a lista de referências (achar a linha que o lápis
   * pediu), a aba "Unidades" da ficha e a decisão de exibir essa aba. Uma delas ficando para trás,
   * a unidade some de uma tela e continua nas outras — que é o defeito mais caro daqui, porque
   * passa despercebido.
   */
  getTiposReferenciaDeUnidade() {
    return ['TRANSMISSAO', 'UNIDADE_DESCRITA'];
  },

  /** Esta referência descreve uma unidade da matrícula-mãe? Ver `getTiposReferenciaDeUnidade`. */
  eReferenciaDeUnidade(tipo) {
    return this.getTiposReferenciaDeUnidade().indexOf(tipo) >= 0;
  },

  getCachedPapeis() {
    return VueBusiness.getVueRoot()?.papeis || [];
  },

  getCachedPapeisByDominio(dominio) {
    let all = this.getCachedPapeis();
    if (!dominio) return all;

    if (DominioBusiness.isDominioLivroUnicoNotas(dominio)) {
      return all.filter(p => p.dominios?.includes(dominio) || p.dominios?.includes('PROTOCOLO_NOTAS'));
    }
    if (dominio.startsWith('CERTIDAO_')) {
      dominio = dominio.replace('CERTIDAO_', 'PROTOCOLO_');
    }

    return all.filter(p => p.dominios?.includes(dominio));
  },

  getPapeisEnvolvidos(params = {}) {
    let {documentacao, dominio} = params;

    let papeis = this.getCachedPapeisByDominio(dominio || 'PROTOCOLO_RI');

    if (documentacao && dominio !== 'DOCUMENTACAO') {
      let papeisDoc = this.getCachedPapeisByDominio('DOCUMENTACAO');
      papeis = [...papeis, ...papeisDoc];
      const unique = Array.from(new Map(papeis.map(obj => [obj.id, obj])).values());
      papeis = Utils.orderBy(unique, 'nome');
    }

    return papeis;
  },

  getSituacoesDoi(){
    return [
      {id : 'CONSTRUCAO_AVERBADA', nome : 'Construção averbada'},
      {id : 'EM_CONSTRUCAO', nome : 'Em construção'},
      {id : 'NAO_SE_APLICA', nome : 'Não se aplica'},
    ]
  },

  getFormasDoi(){
    return [
      {id : 'A_VISTA', nome : 'À vista'},
      {id : 'A_PRAZO', nome : 'A prazo'},
      {id : 'NAO_SE_APLICA', nome : 'Não se aplica'},
    ]
  },

  getTiposOrigens() {
    return [
      {id: 'MATRICULA', nome: 'Matrícula', livro: "MATRICULA", status: 'ABERTA'},
      {id: "PRE_MATRICULA", nome: "Pré-Matrícula", livro: "MATRICULA", status: 'PENDENTE'},
      {id: 'TRANSCRICAO', nome: 'Transcrição', livro: "TRANSCRICAO"},
      {id: 'TORRENS', nome: 'Torrens', livro: "TORRENS"},
      {id: "TEXTO", nome: "Texto"},
      {id: 'MATRICULA_EXTERNA', nome: 'Indicador Real Externo', livro: "MATRICULA"},
    ]
  },

  /**
   * O vínculo é obrigatório em toda referência, MENOS na unidade da matrícula-mãe.
   *
   * A unidade é gravada pela análise de matrícula com `referencia_id` nulo, e é assim de propósito:
   * o lote que a mãe transmitiu pode ainda não ter ficha aberta no acervo, e é justamente essa
   * unidade que aparece na aba "Unidades" com o destino vazio. Enquanto a exigência valia para ela,
   * o conferente abria a linha para corrigir a designação ou a área, clicava em salvar e recebia
   * "O campo de vínculo é obrigatório" sobre uma ficha que não existe — os cinco campos da unidade
   * eram editáveis na tela e inalcançáveis na prática.
   *
   * A régua é o TIPO, a mesma que `ReferenciaImovelForm` usa para decidir se mostra os campos da
   * unidade. Havendo ficha de destino, o vínculo continua sendo o certo a preencher, e o formulário
   * o oferece: o que deixou de existir é a recusa.
   *
   * O ATO tem a mesma história, e a exigência cai num caso só: a unidade de ESTOQUE
   * (`UNIDADE_DESCRITA`) não tem ato por construção — ela existe porque a descrição do imóvel a
   * nomeia, e é justamente nenhum ato tê-la movido que a define. Exigir o número ali deixaria
   * inalcançável para edição toda linha que a análise grava como estoque. Nos demais tipos o ato
   * continua obrigatório, inclusive em TRANSMISSAO.
   */
  getErrosFormReferenciaImovel(form) {
    let validation = {};
    let invalid = false;
    if (!form.tipo) {
      validation.tipo = 'O campo tipo é obrigatório';
      invalid = true;
    }
    if (!form.ato && form.tipo !== 'UNIDADE_DESCRITA') {
      validation.ato = 'O campo ato é obrigatório';
      invalid = true;
    }
    if (!form.referenciaId && !this.eReferenciaDeUnidade(form.tipo)) {
      validation.referenciaId = 'O campo de vínculo é obrigatório';
      invalid = true;
    }
    return invalid ? validation : undefined;

  },

  getErrosFormRegistroAnterior(form) {
    let validation = {};
    let invalid = false;
    // if (!form.serventia) {
    //   validation.serventia = 'O campo serventia é obrigatório';
    //   invalid = true;
    // }
    if (!form.tipo) {
      validation.tipo = 'O campo tipo é obrigatório';
      invalid = true;
    }
    if (!form.registro) {
      validation.registro = 'O campo registro é obrigatório';
      invalid = true;
    }
    if (form.tipo !== 'MATRICULA') {
      // if (!form.livro) {
      //   validation.livro = 'O campo livro é obrigatório';
      //   invalid = true;
      // }
      // if (!form.folha) {
      //   validation.folha = 'O campo folha é obrigatório';
      //   invalid = true;
      // }
    }
    return invalid ? validation : undefined;

  },

  getLabelRegistroAnterior(registro) {
    if (!registro) {
      return 'Novo registro anterior';
    }
    if (registro.interno) {
      registro.serventia = 'Esta Serventia';
    }
    registro.livroNumero = registro.livroNumero === 'null' ? null : registro.livroNumero;
    registro.livroLetra = registro.livroLetra === 'null' ? null : registro.livroLetra;
    const externa = registro.tipo == 'MATRICULA_EXTERNA';
    let livro = externa ? registro.tipoIndicadorRealExterno : registro.tipo;

    let prefix = (registro.tipo != 'TEXTO' && registro.tipo != 'LEGADO' ? livro?.substring(0, 1)?.toUpperCase() : '') || '';
    let label =  prefix + registro.registro;

    label += livro === 'MATRICULA' || livro === 'PRE_MATRICULA' ? `${registro.livroLetra || ''}` : `${registro.livroLetra ? ' Livro ' + (registro.livroNumero||'') + '' + (registro.livroLetra||'') : ''}${registro.folha ? ' Folha ' + registro.folha : ''}`;
    return `${registro.serventia ? registro.serventia + ' - ' : ''}${label}${externa ? ' (externa)': ''}`;
  },

  getCamposInfoComplementar(categoria, unidadeAutonoma) {
    let optionsUA = [];
    if(unidadeAutonoma){
      optionsUA = [{id: 'unidade', tipo: 'text', nome: 'Número da Unidade'},
        {id: 'andar', tipo: 'text', nome: 'Andar'},
        {id: 'bloco', tipo: 'text', nome: 'Bloco'},
        {id: 'pavimento', tipo: 'text', nome: 'Pavimento'},
        {id: 'grupo', tipo: 'text', nome: 'Grupo (Tipo)'}]
    }

    let opt = [
      {id: 'livroLetra', tipo: 'text', nome: 'Livro (Letra)'},
      {id: 'quadra', tipo: 'text', nome: 'Quadra'},
      {id: 'lote', tipo: 'text', nome: 'Lote'},
      {id: 'localizacao', tipo: 'text', nome: 'Localização'},
      {id: 'empreendimento', tipo: 'text', nome: 'Empreendimento/Condomínio'}
    ];



    // if (categoria == 'RURAL') {
    //   opt = [
    //     {id: 'quadra', tipo: 'text', nome: 'Quadra'},
    //     {id: 'lote', tipo: 'text', nome: 'Lote'},
    //     {id: 'localizacao', tipo: 'text', nome: 'Localização'},
    //     {id: 'empreendimento', tipo: 'text', nome: 'Empreendimento'}
    //   ]
    // }

    return Utils.orderBy([...optionsUA, ...opt], 'nome');
  },

  getCamposRegistroAnterio() {
    return [
      {id: 'origens', nome: 'Registro Anterior'},
      {id: 'registroAnterior', nome: 'Registro Anterior'},
      {id: 'serventia', nome: 'Serventia'},
      {id: 'tipo', nome: 'Tipo'},
      {id: 'livro', nome: 'Livro'},
      {id: 'folha', nome: 'Folha'},
      {id: 'registro', nome: 'Registro'},
    ];
  },

  getCamposEndereco() {
    let lista =  [
      {id: 'cep', tipo: 'cep', nome: 'CEP'},
      {id: 'tipoLogradouro', tipo: 'text', nome: 'Tipo Logradouro'},
      {id: 'logradouro', tipo: 'text', nome: 'Logradouro (Rua)'},
      {id: 'numero', tipo: 'text', nome: 'Número'},
      {id: 'bairro', tipo: 'text', nome: 'Bairro (Setor)'},
      {id: 'cidade', tipo: 'select', nome: 'Cidade', options: VueBusiness.getVueRoot()?.cidades},
      {id: 'estado', tipo: 'select', nome: 'Estado', options: EnderecoBusiness.getEstados() },
      {id: 'complemento', tipo: 'text', nome: 'Complemento'},
      {id: 'loteamento', tipo: 'text', nome: 'Loteamento'},
    ];

    if(VueBusiness.getVueRoot().isEstadoRJ){
      lista.push({id: 'subBairro', tipo: 'text', nome: 'Sub-bairro'});
      lista.push({id: 'projetoAprovadoLoteamento', tipo: 'text', nome: 'Projeto Aprovado de Loteamento (PAL)'});
      lista.push({id: 'codigoLogradouro', tipo: 'text', nome: 'Código de Logradouro (CL)'});
    }

    return lista;

  },

  getCamposArea(unidadeAutonoma) {
    if (unidadeAutonoma) {
      return [
        {id: 'medidaArea', tipo: 'text', nome: 'Medida Área'},
        {id: 'area', tipo: 'text', nome: 'Área Total'},
        {id: 'fracaoIdealLivre', tipo: 'text', nome: 'Fração ideal (livre)'},
        {id: 'fracaoSolo', tipo: 'text', nome: 'Fração Solo'},
        {id: 'fracaoSoloPercentual', tipo: 'text', nome: 'Fração Solo (%)'},
        {id: 'coeficienteProporcionalidade', tipo: 'text', nome: 'Coeficiente de proporcionalidade'},
      ];
    } else {
      return [
        {id: 'medidaArea', tipo: 'text', nome: 'Medida Área'},
        {id: 'area', tipo: 'text', nome: 'Área Total'},
        {id: 'fracaoIdealLivre', tipo: 'text', nome: 'Fração ideal (livre)'},
        {id: 'medidaAreaDoi', tipo: 'text', nome: 'Medida Área DOI'},
        {id: 'areaTotalDoi', tipo: 'text', nome: 'Área total DOI'},
      ];
    }
  },

  getCamposEspecificao() {
    return [
      {id: 'especificacao', tipo: 'editor', nome: 'Especificações do Imóvel'},
    ];
  },

  getCamposCadastroIdentificacao(categoria, imovelUniao) {
    let retorno = [];
    if (categoria != 'RURAL' && categoria != '') {
      retorno = [
        {id: 'cadastroImobiliario', tipo: 'text', nome: 'Cadastro Imobiliário'},
        {id: 'cadastroImobiliarioBrasileiro', tipo: 'text', nome: 'Cadastro Imobiliário Brasileiro (CIB)'},
        {id: 'cadastroFiscal', tipo: 'text', nome: 'Cadastro fiscal'},
      ];
    } else {
      retorno = [
        {id: 'denominacao', tipo: 'text', nome: 'Denominação da Área Rural'},
        {id: 'incra', tipo: 'text', nome: 'INCRA (CCIR)'},
        {id: 'codigoSncr', tipo: 'text', nome: 'Código SNCR'},
        {id: 'itr', tipo: 'text', nome: 'ITR'},
        {id: 'car', tipo: 'text', nome: 'CAR'},
        {id: 'certificacaoIncra', tipo: 'text', nome: 'Certificação no SIGEF'},
        {id: 'cadastroImobiliario', tipo: 'text', nome: 'Cadastro Imobiliário'},
        {id: 'cadastroImobiliarioBrasileiro', tipo: 'text', nome: 'Cadastro Imobiliário Brasileiro (CIB)'},
        {id: 'cadastroFiscal', tipo: 'text', nome: 'Cadastro fiscal'},
      ];
    }

    if (imovelUniao) {
      retorno.push({id: 'numeroRipSpu', tipo: 'mask', nome: 'Número RIP SPU'})
      retorno.push({id: 'regime', tipo: 'text', nome: 'Regime (Imóvel da União)'})
      retorno.push({id: 'medidaAreaUniao', tipo: 'text', nome: 'Medida da Área (União)'})
      retorno.push({id: 'areaUniao', tipo: 'text', nome: 'Área Terreno da União'})
    }

    return Utils.orderBy(retorno, 'nome');
  },

  getStatusImovel(completa = true) {
    if (completa) {
      return [
        {id: 'PENDENTE', nome: 'Pendente'},
        {id: 'ABERTA', nome: 'Aberta'},
        {id: 'ENCERRADA', nome: 'Encerrada'},
        {id: 'CANCELADA', nome: 'Cancelada'},
        {id: 'ANULADA', nome: 'Anulada'},
        {id: 'INEXISTENTE', nome: 'Inexistente'},
        {id: 'BLOQUEADA', nome: 'Bloqueada'},
        {id: 'VIRTUAL', nome: 'Virtual'}
      ]
    } else {
      return [
        {id: 'ABERTA', nome: 'Aberta'},
        {id: 'ENCERRADA', nome: 'Encerrada'},
        {id: 'CANCELADA', nome: 'Cancelada'},
        {id: 'ANULADA', nome: 'Anulada'},
        {id: 'INEXISTENTE', nome: 'Inexistente'},
        {id: 'BLOQUEADA', nome: 'Bloqueada'},
      ]
    }
  },

  getLivrosTranscricao(){
    return [
        {id: 'IG', nome: "Livro 1 – Protocolo Geral", sigla: "IG"},
        {id: 'IH', nome: "Livro 2 – Inscrições Hipotecárias", sigla: "IH"},
        {id: 'TT', nome: "Livro 3 – Transcrições das Transmissões", sigla: "TT"},
        {id: 'A', nome: "Livro 3 – Auxiliar", sigla: "A"},
        {id: 'RD', nome: "Livro 4 – Registros Diversos", sigla: "RD"},
        {id: 'ED', nome: "Livro 5 – Emissão de Debêntures", sigla: "ED"},
        {id: 'IR', nome: "Livro 6 – Indicador Real", sigla: "IR"},
        {id: 'IP', nome: "Livro 7 – Indicador Pessoal", sigla: "IP"},
        {id: 'RE', nome: "Livro 8 – Registro Especial", sigla: "RE"},
        {id: 'RA', nome: "Livro 8 – Registro Auxiliar", sigla: "RA"},
        {id: 'RCR', nome: "Livro 9 – Registro de Cédula Rural", sigla: "RCR"},
        {id: 'RCI', nome: "Livro 10 – Registro de Cédula Industrial", sigla: "RCI"},
        {id: 'LT', nome: "Livro Talão", sigla: "LT"},
        {id: 'LTO', nome: "Livro Torrens", sigla: "LTO"},
    ]
  },

  equivalenciaUnidadesImportacao() {
    return [
      {id: 'categoria', label: 'Categoria'},
      {id: 'unidadeAutonoma', label: 'Unidade Autônoma'},
      {id: 'tipoImovel', label: 'Tipo de Imóvel'},
      {id: 'descricaoTipoImovelOutros', label: 'Descrição'},
      {id: 'ultimoAto', label: 'Último Ato'},
      {id: 'unidade', label: 'Número da Unidade'},
      {id: 'bloco', label: 'Bloco'},
      {id: 'quadra', label: 'Quadra'},
      {id: 'lote', label: 'Lote'},
      {id: 'localizacao', label: 'Localização'},
      {id: 'incra', label: 'INCRA (CCIR)'},
      {id: 'codigoSncr', label: 'Código SNCR'},
      {id: 'itr', label: 'ITR'},
      {id: 'car', label: 'CAR'},
      {id: 'andar', label: 'Andar'},
      {id: 'pavimento', label: 'Pavimento'},
      {id: 'grupo', label: 'Grupo (Tipo)'},
      {id: 'cadastroImobiliario', label: 'Cadastro Imobiliário'},
      {id: 'cadastroImobiliarioBrasileiro', label: 'Cadastro Imobiliário Brasileiro (CIB)'},
      {id: 'cep', label: 'CEP'},
      {id: 'logradouro', label: 'Logradouro (rua)'},
      {id: 'numero', label: 'Número'},
      {id: 'cidade', label: 'Cidade'},
      {id: 'bairro', label: 'Bairro (setor)'},
      {id: 'estado', label: 'Estado'},
      {id: 'complemento', label: 'Complemento'},
      {id: 'area', label: 'Área total'},
      {id: 'medidaArea', label: 'Medida Área'},
      {id: 'fracaoIdealLivre', label: 'Fração ideal (livre)'},
      {id: 'fracaoSolo', label: 'Fração Solo'},
      {id: 'fracaoSoloPercentual', label: 'Fração Solo (%)'},
      {id: 'coeficienteProporcionalidade', label: 'Coeficiente de Proporcionalidade'},
      {id: 'especificacao', label: 'Especificações do Imóvel'},
      {id: 'observacao', label: 'Observações Internas'},
      {id: 'certidao', label: 'Observações para Certidão'},
    ]
  },

  listarSigef(imovel){
    return Http.get(`api/v2/sigef/${imovel}`);
  },

  camposConsulta() {
    return Utils.orderBy([
      {unificado: true, livro: null, id: 'categoria', nome: 'Categoria', type: 'list', options: this.getCategorias()},
      {unificado: true, livro: null, status: ['ABERTA','CANCELADA','ENCERRADA','ANULADA','INEXISTENTE','BLOQUEADA'], id: 'status', nome: 'Status/Situação', type: 'list', options: this.getStatusImovel(false)},
      {unificado: true, livro: null, id: 'tipo_imovel', nome: 'Tipo de Imóvel', type: 'list', options: this.getTiposImovel()},
      {unificado: true, livro: null, id: 'descricaoTipoImovelOutros', nome: 'Descrição do Tipo de Imóvel', type: 'text'},
      {unificado: true, livro: null, id: 'unidade', nome: 'Número da Unidade', type: 'text'},
      {unificado: true, livro: null, id: 'bloco', nome: 'Bloco', type: 'text'},
      {unificado: true, livro: null, id: 'quadra', nome: 'Quadra', type: 'text'},
      {unificado: true, livro: null, id: 'lote', nome: 'Lote', type: 'text'},
      {unificado: true, livro: null, id: 'localizacao', nome: 'Localização', type: 'text'},
      {unificado: true, livro: null, id: 'empreendimento', nome: 'Empreendimento/Condomínio', type: 'text'},
      {unificado: true, livro: null, id: 'loteamento', nome: 'Loteamento', type: 'text'},
      {unificado: true, livro: null, id: 'denominacao', nome: 'Denominação da Área Rural', type: 'text'},
      {unificado: true, livro: null, id: 'incra', nome: 'INCRA (CCIR)', type: 'text'},
      {unificado: true, livro: null, id: 'codigoSncr', nome: 'Código SNCR', type: 'text'},
      {unificado: true, livro: null, id: 'itr', nome: 'ITR', type: 'text'},
      {unificado: true, livro: null, id: 'car', nome: 'CAR', type: 'text'},
      {unificado: true, livro: null, id: 'certificacao_incra', nome: 'Certificação no SIGEF', type: 'text'},
      {unificado: true, livro: null, id: 'andar', nome: 'Andar', type: 'text'},
      {unificado: true, livro: null, id: 'pavimento', nome: 'Pavimento', type: 'text'},
      {unificado: true, livro: null, id: 'grupo', nome: 'Grupo (Tipo)', type: 'text'},
      {unificado: true, livro: null, id: 'cadastro_imobiliario', nome: 'Cadastro Imobiliário', type: 'text'},
      {unificado: true, livro: null, id: 'cadastro_imobiliario_brasileiro', nome: 'Cadastro Imobiliário Brasileiro', type: 'text'},
      {unificado: true, livro: null, id: 'cadastro_imobiliario_num', nome: 'Cadastro Imobiliário (Numérico)', type: 'numeric'},
      {unificado: true, livro: null, id: 'cep', nome: 'CEP', type: 'cep'},
      {unificado: true, livro: null, id: 'logradouro', nome: 'Logradouro (rua)', type: 'text'},
      {unificado: true, livro: null, id: 'numero', nome: 'Número', type: 'text'},
      {unificado: true, livro: null, id: 'estado', nome: 'Estado', type: 'list', options: EnderecoBusiness.getEstados()},
      {unificado: true, livro: null, id: 'cidade', nome: 'Cidade', type: 'text'},
      {unificado: true, livro: null, id: 'bairro', nome: 'Bairro (setor)', type: 'text'},
      {unificado: true, livro: null, id: 'complemento', nome: 'Complemento', type: 'text'},
      {unificado: true, livro: null, id: 'especificacao', nome: 'Especificações do Imóvel', type: 'text'},
      {unificado: true, livro: null, id: 'referencia', nome: 'Referências do imóvel', type: 'text'},

      {unificado: true, livro: 'MATRICULA', status: ['ABERTA','CANCELADA','ENCERRADA','ANULADA','INEXISTENTE','BLOQUEADA'], id: 'inconsistente_onr',
        nome: 'Registros Inconsistentes para ONR', type: 'list', options: [{id: true, nome: 'Sim'}, {id: false, nome: 'Não'}]},

      {unificado: true, livro: 'MATRICULA', id: 'cnm', nome: 'CNM', type: 'text'},
      {unificado: true, livro: 'TRANSCRICAO', id: 'livro_transcricao', nome: 'Livro Transcrição', type: 'list', options: this.getLivrosTranscricao()},
      {unificado: true, livro: 'TRANSCRICAO', id: 'livro_numero', nome: 'Livro (Número)', type: 'text'},
      {unificado: true, livro: 'TRANSCRICAO', id: 'livro_folha',  nome: 'Livro (Folha)', type: 'text'},
      {unificado: true, livro: 'TRANSCRICAO', id: 'livro_letra',  nome: 'Livro (Letra)', type: 'text'},

      {unificado: true, livro: null, status: ['ABERTA','CANCELADA','ENCERRADA','ANULADA','INEXISTENTE','BLOQUEADA'], id: 'abertura', nome: 'Data de Abertura', type: 'date'},
      {unificado: true, livro: null, status: ['ABERTA','CANCELADA','ENCERRADA','ANULADA','INEXISTENTE','BLOQUEADA'], id: 'registro', nome: 'Data de Registro', type: 'date'},
      {unificado: true, livro: null, status: ['ABERTA','CANCELADA','ENCERRADA','ANULADA','INEXISTENTE','BLOQUEADA'], id: 'encerramento', nome: 'Data de Encerramento', type: 'date'},
      {unificado: true, livro: null, status: ['ABERTA','CANCELADA','ENCERRADA','ANULADA','INEXISTENTE','BLOQUEADA'],id: 'data_alteracao_manual', nome: 'Data da Alteração Manual', type: 'date'},

      {unificado: true, livro: null, id: 'proprietario_cpf',  nome: 'Proprietário Atual (CPF)', type: 'cpf'},
      {unificado: true, livro: null, id: 'proprietario_cnpj', nome: 'Proprietário Atual (CNPJ)', type: 'cnpj'},
      {unificado: true, livro: null, id: 'proprietario_nome', nome: 'Proprietário Atual (Nome)', type: 'text'},
      {unificado: true, livro: null, id: 'proprietario', nome: 'Proprietário', type: 'list', options: [{id: true, nome: 'Sim'}, {id: false, nome: 'Não'}]},

      {unificado: true, livro: null, id: 'ato_minuta', nome: 'Minuta dos Atos Registrados', type: 'tsquery'},
      {unificado: true, livro: 'MATRICULA', id: 'registros_criterio_inconsistencia', nome: 'Registros com critérios inconsistentes',  type: 'list', options: [{id: true, nome: 'Sim'}, {id: false, nome: 'Não'}]},

      {unificado: true, livro: null, status: ['ABERTA','CANCELADA','ENCERRADA','ANULADA','INEXISTENTE','BLOQUEADA'], id: 'ato_titulo', nome: 'Título dos Atos Registrados', type: 'tsquery'},

      {unificado: true, livro: null, id: 'registro_anterior', nome: 'Registro Anterior'},
      {unificado: true, livro: null, id: 'serventia_registro_anterior', nome: 'Serventia Registro Anterior'},

      {unificado: false, livro: 'MATRICULA', id: 'codigo', nome: 'Matrícula', type: 'number'},
      {unificado: false, livro: 'TRANSCRICAO', id: 'codigo', nome: 'Transcrição', type: 'number'},
      {unificado: true, livro: 'unificado', id: 'codigo', nome: 'Código', type: 'number'},
      {unificado: true, livro: null, id: 'area', nome: 'Área', type: 'area'},

      {unificado: true, livro: null, status: ['ABERTA','CANCELADA','ENCERRADA','ANULADA','INEXISTENTE','BLOQUEADA'], id: 'digitalizacao', nome: 'Digitalização', type: 'list', options: AnexoBusiness.tiposDigitalizacao().slice(1)},
      {unificado: true, livro: null, status: ['ABERTA','CANCELADA','ENCERRADA'], id: 'imagens_digitalizadas', nome: 'Imagens Digitalizadas', type: 'list', options: [{id: 'COM_IMAGEM', nome: 'Com imagem vinculada'}, {id: 'SEM_IMAGEM', nome: 'Sem imagem vinculada'}]},
      {unificado: true, livro: null, status: ['ABERTA','CANCELADA','ENCERRADA'], id: 'atos_registrados', nome: 'Atos Registrados', type: 'list', options: [{id: 'COM_ATO_REGISTRADO', nome: 'Possui ato registrado'}, {id: 'SEM_ATO_REGISTRADO', nome: 'Não possui ato registrado'}]},

      {unificado: true, id: 'registro_auxiliar_id',  nome: 'Registros Auxiliares Relacionados', type: 'registro_auxiliar'},
      {unificado: true, livro: null, id: 'ultimo_ato', nome: 'Último Ato', type: 'numeric'},
      {unificado: false, livro: 'MATRICULA', id: 'doi_tipo_transacao', nome: 'Apenas atos com Operação DOI', type: 'list', options: [{id: true, nome: 'Sim'}]},
      {unificado: false, livro: 'MATRICULA', id: 'matricula_apta_envio_json_onr', nome: 'Indicadores reais aptos para envio no JSON - ONR', type: 'list', options: [{id: true, nome: 'Sim'},{id: false, nome: 'Não'}]},
      {unificado: true, livro: null, id: 'texto_ocr', nome: 'Texto OCR', type: 'text'},
      {unificado: true, livro: null, id: 'sub_bairro', nome: 'Sub-bairro', type: 'text', uf: 'RJ'},
      {unificado: true, livro: null, id: 'projeto_aprovado_loteamento', nome: 'Projeto Aprovado de Loteamento (PAL)', type: 'number', uf: 'RJ'},
      {unificado: true, livro: null, id: 'codigo_logradouro', nome: 'Código de Logradouro (CL)', type: 'text', uf: 'RJ'},
      {unificado: true, livro: null, id: 'nacionalidade_proprietario', nome: 'Nacionalidade do Proprietário'},
      {unificado: true, livro: null, id: 'possui_georreferenciamento', nome: 'Possui Georreferenciamento?', type: 'list', options: [{id: true, nome: 'Sim'}, {id: false, nome: 'Não'}]},
      {unificado: true, livro: null, id: 'tipo_sig', nome: 'Tipo SIG-RI', type: 'list', options: this.getTiposSig()},
      {unificado: true, livro: null, id: 'adequado_provimento_195', nome: 'Adequado ao Provimento 195/CNJ', type: 'list', options: [{id: true, nome: 'Sim'}, {id: false, nome: 'Não'}]},
      {unificado: true, livro: null, id: 'imovel_uniao', nome: 'Imóvel da União', type: 'list', options: [{id: true, nome: 'Sim'}, {id: false, nome: 'Não'}]},
      {unificado: true, livro: null, id: 'numero_poligono', nome: 'Número do Polígono', type: 'text'},
      {unificado: true, livro: null, id: 'numero_rip_spu', nome: 'Número RIP SPU', type: 'text'},
      {unificado: true, livro: null, id: 'cadastro_fiscal', nome: 'Cadastro Fiscal', type: 'text'},
      {unificado: true, livro: null, id: 'unidade_autonoma', nome: 'Unidade Autônoma?', type: 'list', options: [{id: true, nome: 'Sim'}, {id: false, nome: 'Não'}]},
      {unificado: true, livro: null, id: 'bloquear_visualizacao_saec', nome: 'Bloquear a visualização no SAEC conforme a LGPD', type: 'list', options: [{id: true, nome: 'Sim'}, {id: false, nome: 'Não'}]},
      {unificado: true, livro: null, id: 'marinha', nome: 'Imóvel da Marinha', type: 'list', options: [{id: true, nome: 'Sim'}, {id: false, nome: 'Não'}]},
      {unificado: true, livro: null, id: 'fronteira', nome: 'Imóvel de Fronteira', type: 'list', options: [{id: true, nome: 'Sim'}, {id: false, nome: 'Não'}]},
      {unificado: true, livro: null, id: 'area_seguranca_nacional', nome: 'Imóvel em Área de Segurança Nacional', type: 'list', options: [{id: true, nome: 'Sim'}, {id: false, nome: 'Não'}]},
    ], 'nome');
  },
  // IERI

  getOpcoesIERI() {
    return {
      'ADMINISTRACAO': [
        {id: "0 - NÃO APLICÁVEL", nome: "NÃO APLICÁVEL"},
        {id: "1 - ADMINISTRAÇÃO DIRETA", nome: "ADMINISTRAÇÃO DIRETA"},
        {id: "2 - ADMINISTRAÇÃO INDIRETA", nome: "ADMINISTRAÇÃO INDIRETA"},
      ],
      'CIRSCUNCRICAO_TERRITORIAL': [
        {id: "0 - ERRO NO POLÍGNO", nome: "ERRO NO POLÍGNO"},
        {id: "1 - CIRCUNSCRIÇÃO CORRETA", nome: "CIRCUNSCRIÇÃO CORRETA"},
        {id: "2 - CIRCUNSCRIÇÃO DIVERSA", nome: "CIRCUNSCRIÇÃO DIVERSA"},
        {id: "3 - CIRCUNSCRIÇÃO LIMÍTROFES", nome: "CIRCUNSCRIÇÃO LIMÍTROFES"},
      ],
      'ESPECIE_DOMINIO': [
        {id: "1 - PRIVADO", nome: "PRIVADO"},
        {id: "2 - PÚBLICO MUNICIPAL", nome: "PÚBLICO MUNICIPAL"},
        {id: "3 - PÚBLICO ESTADUAL", nome: "PÚBLICO ESTADUAL"},
        {id: "4 - PÚBLICO FEDERAL", nome: "PÚBLICO FEDERAL"},
      ],
      'ESPECIE_IMOVEL_PUBLICO': [
        {id: "1 - BEM DE USO COMUM", nome: "BEM DE USO COMUM"},
        {id: "2 - BEM DE USO ESPECIAL", nome: "BEM DE USO ESPECIAL"},
        {id: "3 - BEM DOMINICAL", nome: "BEM DOMINICAL"},
      ],
      'SOBREPOSICAO_AREA': [
        {id: "0 - NÃO", nome: "NÃO"},
        {id: "1 - SIM", nome: "SIM"},
        {id: "2 - IMPOSSIBILIDADE DE CONSTATAÇÃO", nome: "IMPOSSIBILIDADE DE CONSTATAÇÃO"},
      ],
      'SUBESPECIE_IMOVEL_PUBLICO': [
        {id: "0 - NÃO SE APLICA", nome: "NÃO SE APLICA"},
        {id: "1 - ASSENTAMENTO DE REFORMA AGRÁRIA", nome: "ASSENTAMENTO DE REFORMA AGRÁRIA"},
        {id: "2 - QUILOMBOS", nome: "QUILOMBOS"},
        {id: "3 - RESERVA INDÍGENA", nome: "RESERVA INDÍGENA"},
        {id: "4 - TERRENO DE MARINHA OU ACRESCIDOS", nome: "TERRENO DE MARINHA OU ACRESCIDOS"},
        {id: "5 - *UNIDADE DE CONSERVAÇÃO AMBIENTAL", nome: "*UNIDADE DE CONSERVAÇÃO AMBIENTAL"},
        {id: "6 - OUTROS", nome: "OUTROS"},
      ],
    };
  },

  getFormatters() {
    return [
      {label: 'CNM', key: 'cnm'},
      {label: 'Versão', key: 'versao'},
      {label: 'Categoria', key: 'categoria', type: 'enum', lista: IndicadorRealBusiness.getCategorias()},
      {label: 'Livro - Transcrição', key: 'livroTranscricao', type: 'enum', lista: IndicadorRealBusiness.getLivrosTranscricao()},
      {label: 'Unidade Autônoma', key: 'unidadeAutonoma', type: 'boolean'},
      {label: 'Tipo de Imóvel', key: 'tipoImovel', type: 'enum', lista: IndicadorRealBusiness.getTiposImovel()},
      {label: 'Finalidade de Uso', key: 'finalidadesUso', formatter: (valores) => {
          const lista = IndicadorRealBusiness.getFinalidadesUso();
          return (valores || []).map(id => lista.find(e => e.id == id)?.nome || id).join(', ') || null;
        }},
      {label: 'Outra Finalidade de Uso', key: 'outrasFinalidadesUso', formatter: (valor) => valor || null},
      {label: 'Imóvel da União', key: 'imovelUniao', type: 'boolean'},
      {label: 'Imóvel da Marinha', key: 'marinha', type: 'boolean'},
      {label: 'Imóvel de Fronteira', key: 'fronteira', type: 'boolean'},
      {label: 'Aberta por Decisão Judicial', key: 'decisaJud', type: 'boolean'},
      {label: 'Bloquear a visualização no SAEC conforme a LGPD', key: 'bloquearVisualizacaoSaec', type: 'boolean'},
      {label: 'Descrição', key: 'descricaoTipoImovelOutros'},
      {label: 'Último Ato', key: 'ultimoAto'},
      {label: 'Situação', key: 'status', type: 'enum', lista: IndicadorRealBusiness.getStatusImovel(false)},
      {label: 'Abertura', key: 'abertura', type: 'datetime'},
      {label: 'Cancelamento/Encerramento', key: 'encerramento', type: 'datetime'},
      {label: 'Registro Anterior', key: 'origens', formatter: (registros) => {
          let html = [];
          for (const registro of (registros || [])) {
            const h = `<p>${IndicadorRealBusiness.getLabelRegistroAnterior(registro)}</p>`
            html.push(h);
          }
          return registros?.length ? `${html.join('')}` : null;
        }},
      {label: 'Número RIP SPU', key: 'numeroRipSpu', group: 'Imóvel União', formatter: (registros) => {
          return Utils.formatters.numeroRipSpu(registros);
        }},
      {label: 'Regime', key: 'regime', type: 'enum', lista: IndicadorRealBusiness.getRegimesImovelUniao(), group: 'Imóvel União'},
      {label: 'Medida Área', key: 'medidaAreaUniao', type: 'enum', lista: IndicadorRealBusiness.getMedidasUniao(), group: 'Imóvel União'},
      {label: 'Área Terreno da União', key: 'areaUniao', type: 'decimal', group: 'Imóvel União'},
      {label: 'Fração Ideal (m² ou %)', key: 'fracaoIdealUniao', group: 'Imóvel União'},
      {label: 'Imóvel em Área de Segurança Nacional', key: 'areaSeguracaNacional', type: 'boolean', group: 'Área'},
      {label: 'Livro (Número)', key: 'livroNumero'},
      {label: 'Livro (Letra)', key: 'livroLetra'},
      {label: 'Folha', key: 'livroFolha'},
      {label: 'Número da Unidade', key: 'unidade', group: 'Identificação'},
      {label: 'Bloco', key: 'bloco', group: 'Identificação'},
      {label: 'Quadra', key: 'quadra', group: 'Identificação'},
      {label: 'Lote', key: 'lote', group: 'Identificação'},
      {label: 'Localização', key: 'localizacao', group: 'Identificação'},
      {label: 'Empreendimento/Condomínio', key: 'empreendimento', group: 'Identificação'},
      {label: 'Loteamento', key: 'loteamento', group: 'Identificação'},
      {label: 'Andar', key: 'andar', group: 'Informações Complementares'},
      {label: 'Pavimento', key: 'pavimento', group: 'Informações Complementares'},
      {label: 'Grupo', key: 'grupo', group: 'Informações Complementares'},
      {label: 'Denominação da Área Rural', key: 'denominacao', group: 'Informações Complementares'},
      {label: 'INCRA (CCIR)', key: 'incra', group: 'Informações Complementares'},
      {label: 'Código SNCR', key: 'codigoSncr', group: 'Informações Complementares'},
      {label: 'ITR', key: 'itr', group: 'Informações Complementares'},
      {label: 'CAR', key: 'car', group: 'Informações Complementares'},
      {label: 'Certificação no SIGEF', key: 'certificacaoIncra', group: 'Informações Complementares'},
      {label: 'Cadastro Imobiliário', key: 'cadastroImobiliario', group: 'Informações Complementares'},
      {label: 'Cadastro Imobiliário Brasileiro (CIB)', key: 'cadastroImobiliarioBrasileiro', group: 'Informações Complementares'},
      {label: 'Projeto Aprovado de Loteamento (PAL)', key: 'projetoAprovadoLoteamento', group: 'Endereço'},
      {label: 'Cadastro Fiscal', key: 'cadastroFiscal', group: 'Informações Complementares'},
      {label: 'Coord. Georreferenciadas', key: 'ieri.coordenadasGeorreferencias', type:'boolean', group: 'Dados IERI'},
      {label: 'Duplicidade Material', key: 'ieri.duplicidadeMaterial', type:'boolean', group: 'Dados IERI'},
      {label: 'Reserva Legal Averbada', key: 'ieri.reservaLegalAverbada', type:'boolean', group: 'Dados IERI'},
      {label: 'Possui Georreferenciamento', key: 'possuiGeorreferenciamento', type:'boolean', group: 'Georreferenciamento'},
      {label: 'Coordenadas do Georreferenciamento', key: 'georreferenciamento', group: 'Polígono', formatter: (value) => {
        if (!value) return null;
        if (value.trim().startsWith('{') || value.trim().startsWith('[')) {
          return 'Dados geoespaciais (GeoJSON)';
        }
        return value;
      }},
      {label: 'QR Code SIG - RI', key: 'georreferenciamentoQr',  group: 'Polígono'},
      {label: 'Tipo SIG-RI', key: 'tipoSig', type: 'enum', lista: IndicadorRealBusiness.getTiposSig(), group: 'Georreferenciamento'},
      {label: 'Adequado para o Provimento 195/CNJ', key: 'adequadoProvimento195', type:'boolean', group: 'Georreferenciamento'},
      {label: 'Número do Polígono', key: 'numeroPoligono', group: 'Polígono'},
      {label: 'Descrição do Polígono', key: 'descricaoPoligono', group: 'Polígono'},
      {label: 'Categoria do Polígono', key: 'categoriaPoligono', type: 'enum', lista: [
        {id: 'CATEGORIA_A', nome: 'Categoria A – Georreferenciados rurais com certificação ou urbanos com ART'},
        {id: 'CATEGORIA_B', nome: 'Categoria B – Georreferenciados rurais sem certificação e urbanos sem ART'},
        {id: 'CATEGORIA_C', nome: 'Categoria C – Desenho em imagem de satélite ou google earth'}
      ], group: 'Polígono'},
      {label: 'Sistema de Coordenadas', key: 'sistemaCoordenadas', type: 'enum', lista: [
        {id: 'GEOGRAFICA', nome: 'Geográfica'},
        {id: 'UTM', nome: 'UTM'}
      ], group: 'Polígono'},
      {label: 'Sistema de Referência', key: 'sistemaReferencia', type: 'enum', lista: [
        {id: 'SIRGAS_2000', nome: 'Sirgas 2000'},
        {id: 'SAD_69', nome: 'SAD/69'},
        {id: 'CORREGO_ALEGRE', nome: 'Córrego Alegre'},
        {id: 'ASTRO_CHUA', nome: 'Astro Chuá'},
        {id: 'NAO_INFORMADO', nome: 'Não Informado'}
      ], group: 'Polígono'},
      {label: 'Zona UTM', key: 'zonaUtm', type: 'enum', lista: [
        {id: 'ZONA_18S', nome: '18 S'}, {id: 'ZONA_19S', nome: '19 S'},
        {id: 'ZONA_20S', nome: '20 S'}, {id: 'ZONA_21S', nome: '21 S'},
        {id: 'ZONA_22S', nome: '22 S'}, {id: 'ZONA_23S', nome: '23 S'},
        {id: 'ZONA_24S', nome: '24 S'}, {id: 'ZONA_25S', nome: '25 S'},
        {id: 'NAO_INFORMADO', nome: 'Não Informado'}
      ], group: 'Polígono'},
      {label: 'Formato', key: 'formatoPoligono', type: 'enum', lista: [
        {id: 'GEOJSON', nome: 'GeoJSON/Desenho'},
        {id: 'COORDENADAS', nome: 'Coordenadas (Geo/UTM)'}
      ], group: 'Polígono'},
      {label: 'GeoJSON/Desenho', key: 'nomeArquivoGeojson', group: 'Polígono'},
      {label: 'Imagem QR Code SIG - RI', key: 'qrCodePoligonoImagem', group: 'Polígono', formatter: (value) => {
        if (!value) return null;
        if (value.startsWith('data:image')) return 'Imagem QR Code (arquivo enviado)';
        return value;
      }},
      {label: 'Existe Bloqueio', key: 'ieri.existeBloqueio', type:'boolean', group: 'Dados IERI'},
      {label: 'Administração', key: 'ieri.administracao', type:'enum', lista: IndicadorRealBusiness.getOpcoesIERI()['ADMINISTRACAO'], group: 'Dados IERI'},
      {label: 'Circunscrição Territorial', key: 'ieri.circunscricaoTerritorial', type:'enum', lista: IndicadorRealBusiness.getOpcoesIERI()['CIRSCUNCRICAO_TERRITORIAL'], group: 'Dados IERI'},
      {label: 'Espécie Domínio', key: 'ieri.especieDominio', type:'enum', lista: IndicadorRealBusiness.getOpcoesIERI()['ESPECIE_DOMINIO'], group: 'Dados IERI'},
      {label: 'Espécie de Imóvel Público', key: 'ieri.especieImovelPublico', type:'enum', lista: IndicadorRealBusiness.getOpcoesIERI()['ESPECIE_IMOVEL_PUBLICO'], group: 'Dados IERI'},
      {label: 'Legislação ou Ato Administrativo Aplicável', key: 'ieri.legislacaoAtoAdministrativoAplicavel', group: 'Dados IERI'},
      {label: 'Subespécie de Imóvel Público', key: 'ieri.subespecieImovelPublico', type:'enum', lista: IndicadorRealBusiness.getOpcoesIERI()['SUBESPECIE_IMOVEL_PUBLICO'], group: 'Dados IERI'},
      {label: 'Sobreposição de Área', key: 'ieri.sobreposicaoArea', type:'enum', lista: IndicadorRealBusiness.getOpcoesIERI()['SOBREPOSICAO_AREA'], group: 'Dados IERI'},
      {label: 'Indicador Real', key: 'indicadorRealSobreposto', formatter: async (value) => {
          if (value && Array.isArray(value)) {
            const promises = value.map(async (item) => {
              return await AuditoriaBusiness.nomearFicha(item.id);
            });
            const results = await Promise.all(promises);
            return results.join('<br>');
          }
          return '';
        }
        , group: 'Dados IERI'
      },
      {label: 'CEP', key: 'cep', group: 'Endereço'},
      {label: 'Tipo logradouro', key: 'tipoLogradouro', group: 'Endereço'},
      {label: 'Logradouro', key: 'logradouro', group: 'Endereço'},
      {label: 'Número', key: 'numero', group: 'Endereço'},
      {label: 'Bairro', key: 'bairro', group: 'Endereço'},
      {label: 'Cidade', key: 'cidade', group: 'Endereço'},
      {label: 'Estado', key: 'estado', group: 'Endereço'},
      {label: 'Complemento', key: 'complemento', group: 'Endereço'},
      {label: 'Sub-bairro', key: 'subBairro', group: 'Endereço'},
      {label: 'Código de Logradouro (CL)', key: 'codigoLogradouro', group: 'Endereço'},
      {label: 'Medida Área', key: 'medidaArea', type: 'enum', lista: IndicadorRealBusiness.getMedidas(), group: 'Área'},
      {label: 'Área total', key: 'area', type: 'decimal', group: 'Área'},
      {label: 'Fração ideal (livre)', key: 'fracaoIdealLivre', group: 'Área'},
      {label: 'Medida Área DOI', key: 'medidaAreaDoi', type: 'enum', lista: IndicadorRealBusiness.getMedidas(), group: 'Área'},
      {label: 'Área total DOI', key: 'areaTotalDoi', type: 'decimal', group: 'Área'},
      {label: 'Fração solo', key: 'fracaoSolo', type: 'decimal', group: 'Área'},
      {label: 'Fração solo (%)', key: 'fracaoSoloPercentual', type: 'decimalsimples', group: 'Área'},
      {label: 'Coeficiente de proporcionalidade', key: 'coeficienteProporcionalidade', type: 'decimalSimples', group: 'Área'},
      {label: 'Fração de Tempo', key: 'fracaoTempo', type: 'boolean', group: 'Fração de Tempo'},
      {label: 'Quantidade de dias (fração de tempo)', key: 'quantidadeDiasFracaoTempo', type: 'integer', group: 'Fração de Tempo'},
      {label: 'Distribuição', key: 'distribuicaoFracaoTempo', type: 'integer', group: 'Fração de Tempo'},
      {label: 'Regime de periodicidade de fração de tempo', key: 'regimePeriodicidadeFracaoTempo', group: 'Fração de Tempo'},
      {label: 'Período da fração', key: 'periodosFracaoTempo', group: 'Fração de Tempo', formatter: (registros) => {
          if (typeof registros === 'string') { try { registros = JSON.parse(registros); } catch(e) { registros = []; } }
          let html = [];
          for (const registro of (registros || [])) {
            let h = `<li>`;
            if (registro.inicio) h += `<p>Início: ${Utils.formatters.datetime(registro.inicio, '-', "DD/MM/YYYY - HH:mm:ss")}</p>`;
            if (registro.fim) h += `<p>Fim: ${Utils.formatters.datetime(registro.fim, '-', "DD/MM/YYYY - HH:mm:ss")}</p>`;
            h += `</li>`;
            html.push(h);
          }
          return Array.isArray(registros) && registros.length ? `<ul>${html.join('')}</ul>` : null;
        }},
      {label: '', key: 'areas', formatter: (registros) => {
          let html = [];
          let h = '';
          for (const registro of (registros || [])) {
            h = `<li>`;
            if (!Utils.isEmptyNullOrUndefined(registro.tipo)) {
              h += `<p>Tipo: ${([{id: 'COMUM', nome: 'Comum'}, {id: 'PRIVATIVA', nome: 'Privativa'}]).find(m => m.id === registro.tipo)?.nome}</p>`;
            }
            if (!Utils.isEmptyNullOrUndefined(registro.descricao)) {
              h += `<p>Descrição: ${registro.descricao}</p>`;
            }
            if (!Utils.isEmptyNullOrUndefined(registro.area)) {
              h += `<p>Área: ${Utils.formatters.currency(registro.area)}</p>`;
            }
            h += `</li>`;
            html.push(h);
          }
          return registros?.length ? `<ul>${html.join('')}</ul>` : null;
        }, group: 'Outras Áreas'},
      {label: '', key: 'areasEdificadas', formatter: (registros) => {
          let html = [];
          let h = '';
          for (const registro of (registros || [])) {
            h = `<li>`;
            if (!Utils.isEmptyNullOrUndefined(registro.descricao)) {
              h += `<p>Descrição: ${registro.descricao}</p>`;
            }
            if (!Utils.isEmptyNullOrUndefined(registro.area)) {
              h += `<p>Área: ${Utils.formatters.currency(registro.area)}</p>`;
            }
            h += `</li>`;
            html.push(h);
          }
          return registros?.length ? `<ul>${html.join('')}</ul>` : null;
        }, group: 'Áreas Edificadas'},
      {label: '', key: 'unidadesAcessorias', formatter: (registros) => {
          let html = [];
          let h = '';
          for (const registro of (registros || [])) {
            h = `<li>`;
            if (!Utils.isEmptyNullOrUndefined(registro.descricao)) {
              h += `<p>Descrição: ${registro.descricao}</p>`;
            }
            if (!Utils.isEmptyNullOrUndefined(registro.unidade)) {
              h += `<p>Unidade: ${registro.unidade}</p>`;
            }
            if (!Utils.isEmptyNullOrUndefined(registro.complemento)) {
              h += `<p>Complemento: ${registro.complemento}</p>`;
            }
            if (!Utils.isEmptyNullOrUndefined(registro.area)) {
              h += `<p>Área: ${Utils.formatters.currency(registro.area)}</p>`;
            }
            h += `</li>`;
            html.push(h);
          }
          return registros?.length ? `<ul>${html.join('')}</ul>` : null;
        }, group: 'Unidades Acessórias'},
      {label: '', key: 'confrontacoes', formatter: (registros) => {
          let html = [];
          for (const registro of (registros || [])) {
            let h = `<li><p>Confrontação: ${registro.confrontacao}</p>`;
            h += `<p>Metragem: ${registro.metragem}</p>`;
            h += `<p>Confrontante: ${registro.confrontante}</p>`;
            h += `<p>Lacuna: ${registro.lacuna}</p>`;
            h += `<p>Sobreposição: ${registro.sobreposicao}</p>`;
            if (registro.indicadorRealExterno?.codigo) {
              h += `<p>Indicador Real Externo: ${registro.indicadorRealExterno.codigo}${registro.indicadorRealExterno.livroLetra ? ' - ' + registro.indicadorRealExterno.livroLetra : ''}${registro.indicadorRealExterno.serventia ? ' - ' + registro.indicadorRealExterno.serventia : ''}</p>`;
            }
            if (registro.matricula?.codigo) {
              h += `<p>Matrícula: ${registro.matricula.codigo}${registro.matricula.livroLetra ? ' - ' + registro.matricula.livroLetra : ''}</p>`;
            }
            h += `</li>`;
            html.push(h);
          }
          return registros?.length ? `<ul>${html.join('')}</ul>` : null;
        }, group: 'Confrontações'},
      {label: 'Proprietários', key: 'proprietarios', type: 'string', formatter: (value) => AuditoriaBusiness.proprietarios({proprietarios: value})},
      {label: 'Especificações do Imóvel', key: 'especificacao'},
      {label: 'Observações para Certidão', key: 'certidao'},
      {label: 'Observações Internas', key: 'observacao'},
      {label: 'Registros Vinculados', key: 'registrosVinculados', formatter: async (value) => {
          if (value && Array.isArray(value)) {
            const promises = value.map(async (item) => {
              return await AuditoriaBusiness.nomearFicha(item.id, 'registroAuxiliar');
            });
            const results = await Promise.all(promises);
            return results.join('<br>');
          }
          return '';
        }
      },
      {label: 'Referências', key: 'referencias', formatter: (value) => {
          if (value && Array.isArray(value)) {
            const tipos = IndicadorRealBusiness.getTiposReferencia();
            return value.map(ref => {
              const tipoObj = tipos.find(t => t.id === ref.tipo);
              const tipoLabel = tipoObj ? tipoObj.nome : (ref.tipo || '');
              const parts = [];
              if (tipoLabel) parts.push(tipoLabel);
              if (ref.ato) parts.push(`Ato: ${ref.ato}`);
              if (ref.descricao) parts.push(ref.descricao);
              return parts.join(' — ');
            }).join('<br>');
          }
          return '';
        }
      },
      {label: 'Texto Importado', key: 'textoLegado'},
    ];
  },

  loadCampos(ficha, imovelUniao) {
    let campos = [];
    let camposInfoComplementar = IndicadorRealBusiness.getCamposInfoComplementar(ficha.categoria, ficha.unidadeAutonoma);
    let camposCadastroIdentificao = IndicadorRealBusiness.getCamposCadastroIdentificacao(ficha.categoria, ficha.imovelUniao || imovelUniao);
    let camposEndereco = IndicadorRealBusiness.getCamposEndereco();
    let camposEspecificacao = IndicadorRealBusiness.getCamposEspecificao();
    campos = Utils.orderBy([
      {id: 'registrosVinculados',  nome: 'Registros Auxiliares Relacionados'},
      {id: 'certidao', tipo: 'editor', nome: 'Observações para Certidão'},
      {id: 'observacao', tipo: 'editor', nome: 'Observações Internas'},
      {id: 'referencias', nome: 'Referências'},
      {id: 'camposTipoImovel', nome: 'Tipo de imóvel'},
      {id: 'imovelUniao', tipo: 'radio', nome: 'Imóvel da União'},
      {id: 'marinha', tipo: 'radio', nome: 'Imóvel da Marinha'},
      {id: 'fronteira', tipo: 'radio', nome: 'Imóvel de Fronteira'},
      {id: 'decisaJud', tipo: 'radio', nome: 'Aberta por Decisão Judicial'},
      ...camposInfoComplementar,
      ...camposCadastroIdentificao,
      ...camposEndereco,
      {id: 'camposArea', nome: 'Área'},
      {id: 'camposAreaEdificada', nome: 'Áreas Edificadas'},
      {id: 'camposAreaComum', nome: 'Outras Áreas'},
      {id: 'camposUnidadesAcessorias', nome: 'Unidades Acessórias'},
      {id: 'camposConfrontacoes', nome: 'Confrontações'},
      ...camposEspecificacao,
      {id: 'registroAnterior', nome: 'Registro Anterior'},
      {id: 'finalidadesUso', nome: 'Finalidade de uso', tipo: 'finalidadesUso'},
      {id: 'outrasFinalidadesUso', nome: 'Outra finalidade de uso', tipo: 'text'},
      {id: 'fracaoTempo', tipo: 'radio', nome: 'Fração de Tempo?'},
      {id: 'periodosFracaoTempo', nome: 'Período da fração'},
      {id: 'quantidadeDiasFracaoTempo', nome: 'Quantidade de dias'},
      {id: 'distribuicaoFracaoTempo', nome: 'Distribuição'},
      {id: 'regimePeriodicidadeFracaoTempo', tipo: 'text', nome: 'Regime de periodicidade adotado'},
    ], 'nome');

    if (!ficha.unidadeAutonoma) {
      campos = campos.filter(function (obj) {
        return obj.id !== 'camposAreaComum';
      });
    }

    return campos;
  },

  loadOpcoesConfrontacao(){
    return [
      {id: 'Total',  nome: 'Total'},
      {id: 'Parcial',  nome: 'Parcial'},
      {id: 'Material',  nome: 'Material'},
      {id: 'Meramente Formal',  nome: 'Meramente Formal'},
      {id: 'Nenhuma',  nome: 'Nenhuma'},
    ]
  }

}
